import { useEffect } from 'react';

const useUnmount = (callback: () => void): void => {
    useEffect((): () => void => callback, []);
};

export default useUnmount;
